export default __webpack_public_path__ + "static/media/paper-plane.44106f74.svg";